export const documentStructureRequestIsCurrent = ({
    requestedCaseId,
    activeCaseId,
    requestGeneration,
    activeGeneration,
    aborted = false
} = {}) => (
    !aborted
    && String(requestedCaseId || '') !== ''
    && String(requestedCaseId) === String(activeCaseId || '')
    && Number(requestGeneration) === Number(activeGeneration)
);

export const normalizeDocumentRouteCaseId = (routeCaseId) => {
    const value = String(routeCaseId ?? '').trim();
    return /^[1-9][0-9]*$/.test(value) ? value : null;
};

export const documentFolderRequestIsCurrent = ({
    requestedCaseId,
    activeCaseId,
    aborted = false
} = {}) => (
    !aborted
    && normalizeDocumentRouteCaseId(requestedCaseId) !== null
    && normalizeDocumentRouteCaseId(requestedCaseId) === normalizeDocumentRouteCaseId(activeCaseId)
);
